// This file contains functions for managing bids.

/*
 * Get amazon VAST url for a bid.
 */
export function getVastUrlForAmazonBid(amazonBid) {
  if (amazonBid) {
    const base = 'https://aax.amazon-adsystem.com/e/dtb/vast';
    const url = new URL(base);
    url.searchParams.set('b', amazonBid.targeting?.amzniid);
    url.searchParams.set('pp', amazonBid.targeting?.amznbid);
    url.searchParams.set('rnd', String(Date.now()));
    return url.toString();
  }
  return undefined;
}

/*
 * Decorate a bid with IMA information.
 */
export function decorateBidWithIMAData(videoContainer, bid) {
  var adsManager;
  if (videoContainer && bid.vastUrl && window.google?.ima) {
    var adDisplayContainer = new window.google.ima.AdDisplayContainer(videoContainer);
    var adsLoader = new window.google.ima.AdsLoader(adDisplayContainer);

    adsLoader.addEventListener(
      window.google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED,

      function(adsManagerLoadedEvent) {
        adsManager = adsManagerLoadedEvent.getAdsManager(videoContainer);
        adsManager.init(640, 360, window.google.ima.ViewMode.NORMAL);
        adsManager.addEventListener(window.google.ima.AdEvent.Type.LOADED, function(adEvent) {
          var adData = adEvent.ad.data;
          bid.apiFramework = adData.apiFramework;
          bid.mediaUrl = adData.mediaUrl;
          bid.adWrapperChain = adData.adWrapperSystems.filter(x => x).join('-');
        });
      }, false);

    var adsRequest = new window.google.ima.AdsRequest();
    adsRequest.adTagUrl = bid.vastUrl;
    adsLoader.requestAds(adsRequest, bid);
  }

  return bid;
}

export async function blobToData(bid) {
  const response = await fetch(bid.vastUrl);
  if (response.ok) {
    const blobContent = await response.text();
    const base64 = btoa(unescape(encodeURIComponent(blobContent)));

    bid.vastUrl = `data:text/xml;base64,${base64}`;
  }

  return bid;
}
